function handleStickyNav() {
  const sectionNavSticky = document.getElementById('sectionNavSticky')
  const sectionNavTitle = document.getElementById('secNavMenuOffcanvasLabel')
  const stickyNavTitle = document.getElementById('sectionStickyNavTitle')
  const offcanvasOffsetElement = document.querySelector('.navigation-bar-mobile')
  let topOffset = offcanvasOffsetElement.getBoundingClientRect().bottom
  if (sectionNavSticky && sectionNavTitle) {
    let navTitle = sectionNavTitle.innerHTML
    stickyNavTitle.innerHTML = navTitle
    window.addEventListener('scroll', function () {
      var elementTarget = document.getElementById('sectionNavButton');
      if ((window.scrollY + topOffset) > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
        if (sectionNavSticky.style.display === 'none') {
          sectionNavSticky.style.display = 'flex'
        }
      }
      if ((window.scrollY + topOffset) <= (elementTarget.offsetTop + elementTarget.offsetHeight)) {
        if (sectionNavSticky.style.display === 'flex') {
          sectionNavSticky.style.display = 'none'
        }
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', (event) => {
  handleStickyNav()
});
